<template>
  <div>
    <div v-if="currentStatus == 1 || currentStatus == 0" class="status-circle d-inline-block" :class="(currentStatus == 1)? 'connected' : 'disconnected'"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      currentStatus: 0,
      interval: null,
      img: null
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    checkServerStatus()
    {
      this.setServerStatus(0);
      this.img = document.createElement("img");
      this.img.onload = () =>
      {
        this.setServerStatus(1);
      };
      this.img.onerror = () =>
      {
        this.setServerStatus(0);
      };
      this.img.src = (this.params.data.url) + '/alive_proof.gif?t=' + performance.now() +'key=' + this.params.data.api_key
    },
    setServerStatus (status) {
      this.currentStatus = status
    },
  },
  beforeMount() {
    this.url = (this.params.data.url) + '/alive_proof.portal?key=' + this.params.data.api_key
    this.checkServerStatus()
    this.interval = setInterval( () => {
      delete this.img
      this.checkServerStatus()
    }, 5000)
  }
}
</script>
